import React, { useState, useEffect, useRef } from "react";
import { Tabulator, FormatModule, EditModule } from 'tabulator-tables';
import "tabulator-tables/dist/css/tabulator.min.css";
import validateRow from '../validators/RowValidator.js';
import { Button } from "@material-ui/core";

Tabulator.registerModule([FormatModule, EditModule]);

const ZoneEditableSpreadSheet = ({ tableData, upload, pbarbgref, pbarref }) => {
    const tableRef = useRef(null);
    const saveButtonRef = useRef(null);
    const [tabulatorInstance, setTabulatorInstance] = useState(null);

    useEffect(() => {
        if (tableData[0] && !tabulatorInstance) {
            const instance = new Tabulator(tableRef.current, {
                reactiveData: true,
                data: tableData,
                maxHeight: 500,
                layout: "fitColumns",
                selectable: 1,
                columns: [
                    { title: "Custom ID", field: "customID", editor: false },
                    { title: "Message Prefix", field: "message_prefix", editor: false },
                    { title: "Notes", field: "notes", editor: false },
                    { title: "Serial #", field: "serialNo", editor: false },
                ]
            });

            setTabulatorInstance(instance);
            tableRef.current.style.display = 'inline-block';
            saveButtonRef.current.style.display = 'inline-block';
        }
    }, [tableData, tabulatorInstance]);

    return (
        <div>
            <div>
                <Button ref={saveButtonRef} style={{ 
                    color: 'white',
                    borderRadius: "10px",
                    backgroundColor: "#03a9f4",
                    margin: '10px',
                    display: 'none'
                 }} onClick={upload}>
                    Upload
                </Button>
            </div>
            <div>
                <div ref={pbarbgref} style={{ 
                    position: 'relative',
                    margin: '20px',
                    width: '80%',
                    height: '20px',
                    backgroundColor: 'gray',
                    display: 'none'
                 }}>
                    <div ref={pbarref} style={{ 
                        position: 'absolute',
                        height: '20px',
                        color: 'white',
                        fontWeight: 'bold',
                        fontFamily: 'verdana',
                        fontSize: '14px',
                        backgroundColor: '#03a9f4',
                        textAlign: 'center',
                        display: 'none'
                    }}></div>
                </div>
            </div>
            <div style={{ 
                width: '80%',
                height: '80%',
                color: 'gray',
                fontFamily: 'verdana',
            }} ref={tableRef} />
        </div>
    );
}

export default ZoneEditableSpreadSheet;
